// Importy modułów Swiper
const { Navigation, Pagination, Autoplay } = window;

// Rejestracja modułów globalnie dla Swiper (tylko te dostępne)
if (window.Swiper) {
    const mods = [];
    if (window.SwiperNavigation) mods.push(window.SwiperNavigation);
    if (window.SwiperPagination) mods.push(window.SwiperPagination);
    if (window.SwiperAutoplay) mods.push(window.SwiperAutoplay);
    if (mods.length) window.Swiper.use(mods);

    if (document.querySelector('.js-hero-slider')) {
        new window.Swiper('.js-hero-slider', {
            slidesPerView: 1,
            spaceBetween: 50,
            loop: true,
            speed: 700,
            autoplay: false,
            pagination: {
                el: '.hero__slider-pagination',
                type: 'fraction',
                renderFraction(currentClass, totalClass) {
                    return `<span class="${currentClass}"></span> z <span class="${totalClass}"></span>`;
                }
            },
            navigation: {
                prevEl: '.hero__arrow--prev',
                nextEl: '.hero__arrow--next'
            }
        });
    }

    if (document.querySelector('.js-courses-categories-slider')) {
        new window.Swiper('.js-courses-categories-slider', {
            slidesPerView: 1.15,
            spaceBetween: 24,
            speed: 700,
            grabCursor: true,
            watchOverflow: true,
            pagination: {
                el: '.courses-categories__pagination',
                type: 'fraction',
                renderFraction(currentClass, totalClass) {
                    return `<span class="${currentClass}"></span> z <span class="${totalClass}"></span>`;
                }
            },
            navigation: {
                prevEl: '.courses-categories__arrow--prev',
                nextEl: '.courses-categories__arrow--next'
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }
}



// var swiper = new Swiper(".specjalizacjeSwiper", {
//   grabCursor: false,
//   simulateTouch: false,
//   slidesPerView: 3,
//   spaceBetween: 16,
//   loop: true,
//   navigation: {
//       nextEl: ".specjalizacjeSwiper-next",
//       prevEl: ".specjalizacjeSwiper-prev",
//     },
// });


// $(function() {
//   $('.twentytwenty-init').twentytwenty({
//     orientation: 'vertical',
//     move_with_handle_only: true,
//   });
// })

